module.exports = "/_next/static/images/waves-d0d8d333415baa8cacab73174be929ed.svg";